import {fetchBody} from "../../config"
import { toLogout, cleanFetch } from "../apiTools";
import { getToken } from "../../component/Login/Auth";
import { URL_PLAYER_HISTORY_GET_LIST, URL_PLAYER_HISTORY_ADD, URL_PLAYER_HISTORYList_EDIT, URL_PLAYER_LEAGUE_GET_LIST } from "../../setup/config_mystat";

export function api_getPlayerLeagueList ({player_id, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: {player_id}, token}), 
      url: URL_PLAYER_LEAGUE_GET_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_getPlayerHistoryList ({mReqPlayerHistoryList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqPlayerHistoryList, token}), 
      url: URL_PLAYER_HISTORY_GET_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_addPlayerHistory ({mRespPlayerHistory, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mRespPlayerHistory, token}), 
      url: URL_PLAYER_HISTORY_ADD, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_updatePlayerHistorys ({player_history_list, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: player_history_list, token}), 
      url: URL_PLAYER_HISTORYList_EDIT, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

